"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UploadState = exports.FileType = void 0;
var FileType;
(function (FileType) {
    FileType["GENERAL"] = "GENERAL";
    FileType["DISCLOSURE"] = "DISCLOSURE";
    FileType["COLLABORATOR"] = "COLLABORATOR";
    FileType["HOD"] = "HOD";
    FileType["DEAN"] = "DEAN";
    FileType["DRD"] = "DRD";
    FileType["TTO_DIRECTOR"] = "TTO_DIRECTOR";
    FileType["ASSESSMENT"] = "ASSESSMENT";
    FileType["LICENSING"] = "LICENSING";
    FileType["PATENTS"] = "PATENTS";
    FileType["FORM_ATTACHMENT"] = "FORM_ATTACHMENT";
})(FileType || (exports.FileType = FileType = {}));
var UploadState;
(function (UploadState) {
    UploadState["PENDING"] = "PENDING";
    UploadState["FAILED"] = "FAILED";
    UploadState["SUCCESS"] = "SUCCESS";
})(UploadState || (exports.UploadState = UploadState = {}));
